import React, { useState, useEffect } from "react";
import Alert from "@material-ui/lab/Alert";
import moment from "moment";
// I18n
import { useTranslation } from "react-i18next";
import { Grid, Button, makeStyles, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import {
  durationOptions,
  dateConfig,
  timeConfig,
  defaultSelection,
} from "../config";
import { properCase } from "utils";
import { clockedInMock } from "config/mock";

const useStyles = makeStyles({
  tableContainer: {},
  table: {
    // minWidth: 650,
    // marginBottom: 20
  },
  formControl: {
    //margin: theme.spacing(1),
    minWidth: 150,
    // marginBottom: 20,
  },
  selectEmpty: {
    //marginTop: theme.spacing(2),
  },
  highlight: {
    backgroundColor: "#FDECEA",
  },
  full: {
    // width: "98%",
  },
});

const HighDuration = (props) => {
  const { data } = props,
    { t } = useTranslation(),
    classes = useStyles(),
    [duration, setDuration] = useState(defaultSelection),
    punches = data != null && data != undefined ? data : [];

  const handleDurationChange = (event) => {
    setDuration(event.target.value);
  };


  return (
    <>
      {punches.length > 0 ? (
        <>

          <TableContainer 
            component={Paper}
            className={classes.tableContainer}
            elevation="6"
          >
            <Table
              className={classes.table}
              size="small"
              aria-label="a dense table"
            >
              <TableHead>
                <TableRow>
                  <TableCell align="left">{t("pgHome.lblName")}</TableCell>
                  <TableCell align="left">
                    {properCase(t("pgHome.lblActivityName"))}
                  </TableCell>
                  <TableCell align="left">
                    {properCase(t("pgHome.lblJobFamily"))}
                  </TableCell>
                  <TableCell align="left">
                    {properCase(t("pgHome.lblTimeStamp"))}
                  </TableCell>
                  <TableCell align="left">
                    {properCase(t("pgReview.tableHeads.endTime"))}
                  </TableCell>
                  <TableCell align="right">
                    {properCase(t("pgHome.lblDuration"))}
                  </TableCell>
                  {/* <TableCell align="right">{t("pgHome.lblWeeklyTotal")} </TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {punches.map((punch) => (
                  <TableRow
                    key={punch.name}
                    className={
                      punch.duration >= duration && duration !== "-1"
                        ? classes.highlight
                        : null
                    }
                  >
                    <TableCell component="th" scope="row">
                      {punch.name} ({punch.workerId})
                    </TableCell>
                    <TableCell align="left">{
                    punch.activityGroup ?

                    punch.activityGroup.toUpperCase() === "TRANSACTIONAL" ?                        
                     properCase(t("pgHome.reportlabel2Transcational")) :
                         
                    punch.activityGroup.toUpperCase() === "PROJECT" ?
                    properCase(t("pgHome.reprotlabel3Project")) :
                        
                    punch.activityGroup.toUpperCase() === "NON-TRANSACTIONAL" ?
                    properCase(t("pgHome.reportlabel1Non-Transactional")) :

                    punch.activityGroup.toUpperCase() === "LEAVE" ?
                    properCase(t("other.lblLeave")) :

                    punch.activityGroup.toUpperCase() === "MEAL" ?
                    properCase(t("other.tlMeal")) :
                        
                    punch.activityGroup.toUpperCase() === "BUILDING MOVES" ?
                    properCase(t("other.tlbuildingmoves")) :

                          punch.activityGroup :

                          "NA"
                        
                    }</TableCell>
                    <TableCell align="left">{punch.jobName}</TableCell>
                    <TableCell align="left">
                      {moment(punch.inLocalTS).format(dateConfig.format3) +
                        " " +
                        moment(punch.inLocalTS).format(timeConfig.format3)}
                    </TableCell>
                    <TableCell align="left">
                      {moment(punch.outLocalTS).format(dateConfig.format3) +
                        " " +
                        moment(punch.outLocalTS).format(timeConfig.format3)}
                    </TableCell>
                    <TableCell align="right">{punch.duration}</TableCell>
                    {/* <TableCell align="right">{row.weeklyTotal}</TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      ) : (
        <>
          <Alert severity="info" className={classes.full}>
            {t("pgHome.errNoReportData2")}
          </Alert>
        </>
      )}
    </>
  );
};

HighDuration.propTypes = {
  data: PropTypes.array,
};

export default HighDuration;
